import { type FC } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { URL_ROUTES } from '@/constants';
import { BuyNowEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import IdleTimeIcon from '@/Pages/BuyNowPage/partials/icons/IdleTime';

interface IdleTimeProps {
  isOpen: boolean;
  onClose: () => void;
}

const TITLE_LABEL = '¡El tiempo se agotó!';
const DESCRIPTION_LABEL =
  'Tu pedido está por cancelarse. Completa el pago ahora para asegurar tu compra.';
const EXIT_BUTTON_LABEL = 'Salir';
const COMPLETE_PURCHASE_BUTTON_LABEL = 'Continuar con el pago';

const originURL = typeof window !== 'undefined' ? window.location.origin : '';

const IdleTimeModal: FC<IdleTimeProps> = ({ isOpen, onClose }) => {
  const goHome = () => {
    window.location.href = `${originURL}${URL_ROUTES.BASE_HOME}`;
  };
  return (
    <Modal size="sm" isOpen={isOpen}>
      <ModalHeader
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
      />
      <ModalBody className="co-flex co-flex-col co-p-6 co-pt-0 co-gap-4 co-mb-0 co-mt-0">
        <div>
          <div className="co-flex co-flex-col co-gap-2.5 co-p-3 co-pb-0 co-items-center">
            <IdleTimeIcon />
            <Text
              variant="subtitle1"
              weight={700}
              color="primary-500"
              className="mobile:co-text-20px mobile:co-leading-26px"
            >
              {TITLE_LABEL}
            </Text>
            <Text
              variant="body2"
              weight={400}
              fixed
              className="co-text-center co-text-balance"
            >
              {DESCRIPTION_LABEL}
            </Text>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="co-flex co-flex-col-reverse tablet:co-flex-row co-justify-end co-gap-2 [&>*]:co-w-full tablet:[&>*]:co-w-fit">
        <Button
          block
          size="xl"
          variant="secondary"
          loading={false}
          onClick={() => {
            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag':
                  BuyNowEventInteractiveTags.ExitIdleModalSalir
              }
            });
            goHome();
          }}
        >
          {EXIT_BUTTON_LABEL}
        </Button>
        <Button
          size="xl"
          variant="primary"
          onClick={() => {
            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag':
                  BuyNowEventInteractiveTags.ExitIdleModalCompletarCompra
              }
            });
            onClose();
          }}
          loading={false}
        >
          {COMPLETE_PURCHASE_BUTTON_LABEL}{' '}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default IdleTimeModal;
